import React, { useState } from 'react'
import SampleBulkProductCSv from '../../../../../images/SampleBulkProductCSv.xlsx'
import { uploadProductsBulk } from '../../AdminActionCreator.component';
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
export default function uploadBulkProduct() {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [loader, setLoader] = useState(false);
    const [popup, setpopup] = useState({show:false,popupStatus:""});


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setFileName(file.name);
        }
    };

    const downloadsample = () => {
        setLoader(true)
        fetch(SampleBulkProductCSv)
            .then(response => response.blob())
            .then(blob => {

                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = 'Sample';
                link.click();
            })
            .catch(console.error)
            .finally(setLoader(false));

    }

    const handleSave = () => {
        setLoader(true)
        uploadProductsBulk(selectedFile, callback => {
            setLoader(false)
            console.log(callback)
            const data = JSON.parse(callback)
            if(data?.message == "success" && data?.status == 200){
                setpopup({show:true,popupStatus:'File Uploaded Successfully'})
            }else{
                 setpopup({show:true,popupStatus:'Error Uploading File'})
            }

            removePopup()
        })
    }

    const closePopup =()=>{
        setpopup({show:false,popupStatus:''})
    }
    const removePopup = ()=>{
        setTimeout(()=>{
closePopup()
        },5000)
    }
    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className="container-fluid">
                <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                    <div className="col-sm-7 col-xs-12">
                        <div style={{ border: "1px solid rgba(0, 0, 0, 0.1)", background: 'rgb(250, 250, 250)', padding: '10px', borderRadius: '12px' }}>
                            <div className='marketing-css'>
                                <div className="upload-main" style={{ background: 'rgba(219, 233, 255, 0.7)' }}>
                                    <div className="image-upload-div">
                                        <input type="file" accept=".xlsx, .xls" className='file-upload-input' style={{ padding: '20px' }} onChange={handleFileChange} />
                                        <div className="drag-text-new" style={{ color: 'rgba(0, 0, 0, 0.4)', marginTop: '10px' }}>
                                            <h5 className="upload-icon" style={{ backgroundPosition: "30% center" }}>{fileName ? `${fileName}` : "Upload XLS"}</h5>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ marginTop: '20px', display: "flex", justifyContent: 'center', gap: '20px' }}>
                                    <button className='btn btn-primary' onClick={() => downloadsample()}><i className='fa fa-download'></i> &nbsp;Download Sample CSV File</button>
                                    <button className='btn btn-primary' onClick={() => handleSave()}><i className='fa fa-upload'></i> &nbsp;Upload XLS</button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
